var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trbo-a-questions-header" }, [
    _c("div", { staticClass: "trbo-a-questions-header__top" }, [
      _c(
        "div",
        { staticClass: "trbo-a-questions-header__top__avatar" },
        [
          _c("question-avatar", {
            attrs: {
              "image-url": _vm.settings.avatar.imageUrl,
              name: _vm.settings.avatar.name,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trbo-a-questions-header__top__progress-bar" },
        [
          _c("question-progress-bar", {
            attrs: { settings: _vm.settings.progressBar },
            on: { "progress-bar-item-click": _vm.onProgressBarItemClick },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "trbo-a-questions-header__top__buttons" },
        [
          _c("question-restart-button", {
            attrs: { disabled: _vm.isDisabledRestartButton },
            on: { click: _vm.onClickRestart },
          }),
          _vm._v(" "),
          _vm.settings.showCloseButton
            ? _c(
                "div",
                { staticClass: "trbo-a-questions-header__top__buttons__close" },
                [
                  _c("question-close-button", {
                    on: { click: _vm.onClickGoToLandingPage },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _vm.settings.topMessage
      ? _c(
          "div",
          { staticClass: "trbo-a-questions-header__bottom" },
          [
            _vm.settings.topMessage.title || _vm.settings.topMessage.description
              ? _c("top-message", {
                  attrs: {
                    title: _vm.settings.topMessage.title,
                    description: _vm.settings.topMessage.description,
                  },
                  on: { "link-from-message-click": _vm.onClickLinkFromMessage },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.settings.isCurrentProductsPage && _vm.settings.isSortingEnabled
      ? _c(
          "div",
          { staticClass: "trbo-a-questions-header__actions" },
          [_c("sort-dropdown")],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.settings.isSearchEnabled
      ? _c(
          "div",
          { staticClass: "trbo-a-questions-header__search-box" },
          [
            _c("search-box", {
              attrs: { "initial-value": _vm.settings.optionSearchQuery },
              on: {
                search: function (query) {
                  return _vm.$emit("search", query)
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }